import { isUserError } from '@/services/apollo/userErrorLink'
import { useShowAppError } from '@/services/appErrors/appErrorAtom'
import { type OfferRecommendationFragment, useStartDateUpdateMutation } from '@/services/graphql/generated'
import { logger } from '@/services/logger/logger.client'
import { formatAPIDate } from '@/utils/date'

export function useUpdateOfferStartDate() {
  const showError = useShowAppError()
  const [updateStartDate] = useStartDateUpdateMutation({
    // Callers swallow the rejection to keep the previous date, so this is the only place a refusal becomes visible.
    onError(error) {
      if (!isUserError(error)) {
        logger.error('Cross sell | failed to update offer start date', { error })
      }
      showError(error)
    },
  })

  return async (offerId: string, startDate: Date): Promise<OfferRecommendationFragment> => {
    const { data } = await updateStartDate({
      variables: {
        productOfferIds: [offerId],
        startDate: formatAPIDate(startDate),
      },
    })

    const updatedOffer = data?.productOffersStartDateUpdate.productOffers[0]

    if (!updatedOffer) {
      throw new Error(`Cross sell | failed to update offer (${offerId}) startDate (${startDate})`)
    }

    return updatedOffer
  }
}
